
/**
 * type为content时使用容器的宽度，为lastchild时使用最后一个子元素的offsetLeft
 * 使用lastchild时需要填写child的参数
 */
let defaultConfig = {
    step: 10, //步长
    duration: 400, //滚动时长
    ease: 'ease',//滚动的动画类型
    type: 'content',//选择参照的方式
    child: '' //选择type为lastchild时必传
}


/**
 * 针对使用flex布局后无法使用横向滚动的小插件
 * @param {string|HTMLElement} el 
 * @param {Object<defaultConfig>} options
 */
export default function (el, _options) {
    /**
     * @type {Element}
     */
    let element = el;
    let options = Object.assign({}, defaultConfig, _options)
    if (typeof el === 'string') {
        element = document.querySelector(el)
    }

    if (options.type === 'lastchild' && !options.child) {
        console.error('请传入child的参数')
        return;
    }

    let child = element.lastChild;

    child.style.transition = `all ${options.duration / 1000}s ${options.ease}`;

    let scrollDistance = 0; //滚动的距离
    let typeChild = document.querySelectorAll(options.child)

    let lastchid = typeChild[typeChild.length - 1];

    let offsetLeft = options.type === 'lastchild' ? lastchid ? ~lastchid.offsetLeft / 2 : -100 : -100;

    element.addEventListener('mousewheel', function (evt) {
        let deltaY = evt.deltaY;
        // 向下滚动
        if (deltaY > 0) {
            if (scrollDistance > offsetLeft) {
                scrollDistance -= options.step;
            }
        } else {
            if (scrollDistance < 0) {
                scrollDistance += options.step;
                
            }
        }
        
        child.style.transform = options.type === 'content' ? `translateX(${scrollDistance}%)` : `translateX(${scrollDistance}px)`;
        _options.onscroll && _options.onscroll(scrollDistance);
        
    })

    return this;
}